import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';

export interface CourierOption {
    id: number;
    name: string;
}

export const useCouriersDropdown = () => {
    const httpClient = createHttpClient(apiClientWH);

    const { data, isLoading } = useQuery({
        queryKey: ['couriers-dropdown'],
        queryFn: async () => {
            try {
                const raw = await httpClient.get<any>('/couriers');
                // La API puede devolver directamente un array o un objeto con propiedad data
                const list = Array.isArray(raw) ? raw : (raw.data ?? []);
                return list.map((courier: any) => ({
                    id: parseInt(String(courier.id), 10),
                    name: courier.name,
                })) as CourierOption[];
            } catch (error) {
                console.error('Error loading couriers:', error);
                return [];
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
        gcTime: 10 * 60 * 1000, // 10 minutos
    });

    return {
        couriers: data ?? [],
        isLoading,
    };
};

